<template>
  <div class="wrap">
    <!-- <ul>
      <li
        v-for="(tab,index) in tabs"
        @click="toggle(index,tab)"
        :class="{'active':active==index}"
      > {{ tab.type }} </li>
    </ul> -->
    <template v-if="currentView === 'netAnswer'">
      <answer-component
        :header-list="headerList"
        :t-header="tHeader"
        :filter-val="filterVal"
        :query-form="forms"
        :opt="costNetAnswerOptions"
      />
    </template>
    <template v-else>
      <spread-component
        :header-list="spreadHeaderList"
        :opt="costNetSpreadOptions"
        :query-form="spreadForms"
        :t-header="spreadTHeader"
        :filter-val="spreadFilterVal"
      />
    </template>
  </div>
</template>
<script>
import answerComponent from '../components/AnswerComponents'
import spreadComponent from '../components/SpreadComponents'
import { costNetAnswerOptions, costNetSpreadOptions } from '../components/getCostList'
export default {
  components: { answerComponent, spreadComponent },
  props: {
    currentView: {
      type: String,
      default: 'netAnswer'
    }
  },
  data() {
    return {
      active: 0,
      headerList: [
        {
          text: '已发放奖励金额(元)',
          value: 'paid'
        },
        {
          text: '已获得奖励答卷数(份)',
          value: 'answerNum'
        },
        {
          text: '已设置奖励总额(元)',
          value: 'amount'
        },
        {
          text: '已设置奖励红包数(份)',
          value: 'answerAmount'
        }
      ],
      tHeader: ['奖励产生流水号', '答卷ID', '奖励名称', '答卷样本ID', '审核方式', '奖励金额(元)', '奖励产生时间'],
      filterVal: ['codes', 'answerId', 'jlName', 'yangId', 'examType', 'money', 'times'],
      forms: {
        dates1: '', // 奖励产生时间
        answerChannel: '', // 子渠道
        answerId: '', // 答卷样本id
        sendStatus: '', // 发放状态 0失败 1成功 2等待
        // needHasAward: '1' // 奖励金额 0全部，1金额>0
      },
      costNetAnswerOptions,
      costNetSpreadOptions,
      spreadHeaderList: [
        {
          text: '已发放奖励金额(元)',
          value: 'paid'
        },
        {
          text: '已产生奖励次数(份)',
          value: 'answerNum'
        },
        {
          text: '已获得奖励人数',
          value: 'peopleNum'
        },
        {
          text: '已设置可产生奖励总额(元)',
          value: 'amount'
        },
        {
          text: '已设置可产生奖励总次数',
          value: 'answerAmount'
        }
      ],
      spreadForms: {
        dates1: '', // 奖励产生时间
        answerChannel: '', // 子渠道
        answerId: '', // 答卷样本id
        sendStatus: '', // 发放状态 0失败 1成功 2等待
        // needHasAward: '1' // 奖励金额 0全部，1金额>0
      },
      spreadTHeader: ['奖励产生流水号', '答卷ID', '奖励名称', '传播样本ID', '奖励金额(元)', '奖励产生时间'],
      spreadFilterVal: ['codes', 'answerId', 'jlName', 'yangId', 'money', 'times']
    }
  },
  methods: {
    // toggle(i, v) {
    //   this.active = i
    //   this.currentView = v.view
    // }
  }
}
</script>
<style scoped lang="scss">
.wrap {
  width: 100%;

  ul {
    display: flex;
    margin-bottom: 20px;

    li {
      width: 101px;
      height: 36px;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid rgba(220, 223, 230, 1);
      display: inline-flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(48, 49, 51, 1);
    }
  }
}

.active {
  background: rgba(230, 241, 252, 1);
  color: #1989fa !important;
}
</style>
